import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { map, isEmpty, get } from 'lodash-es'
import { intl } from 'lang/intl'
import {
  If,
  MetricsBarComponent,
  MetricSingleComponent,
  Button,
  ClipboardButtonComponent,
} from '../../../sharedLegacy/components'
import { ScheduleTimerComponent } from '..'

import './WebinarOverlayComponent.scss'

const getHeading = (properties) => {
  const {
    isProducer,
    webinarViewLink: link,
    isPresenterAloneBeforeWebinar,
    schedule,
    onLiveCountdownZero,
  } = properties

  if (isProducer) {
    return (
      <>
        <div className="name">
          <FormattedMessage defaultMessage="Congratulations!" />
        </div>
        <p className="webinar-ended-message">
          <FormattedMessage defaultMessage="Your webinar ended successfully" />
        </p>
      </>
    )
  }

  return (
    <>
      <div className="heading-wrapper">
        <div className="name">
          {isPresenterAloneBeforeWebinar
            ? intl.formatMessage({
                defaultMessage: 'Hey! Your webinar will start in',
              })
            : intl.formatMessage({
                defaultMessage: 'Hey! This webinar has ended.',
              })}
        </div>
        {isPresenterAloneBeforeWebinar && (
          <ScheduleTimerComponent
            startTimeEpoch={get(schedule, 'start_time_epoch')}
            onLiveCountdownZero={onLiveCountdownZero}
            renderOnlyTimer
          />
        )}
      </div>
      {isPresenterAloneBeforeWebinar && (
        <p className="help-text">
          <FormattedMessage defaultMessage="You can prepare yourself until that time to make sure things will run smoothly." />
        </p>
      )}
      <If condition={!isEmpty(link)}>
        <div className="copy-link-text">
          <div>
            <FormattedMessage defaultMessage="Copy the link of your webinar so you can share it." />
          </div>
          <div className="link-wrapper">
            <a
              href={link}
              className="link"
              rel="noopener noreferrer"
              target="_blank"
            >
              {link}
            </a>
            <ClipboardButtonComponent text={link} />
          </div>
        </div>
      </If>
    </>
  )
}

const WebinarOverlayComponent = (props) => {
  const {
    isProducer,
    localParticipantName: name,
    webinarOverMetrics,
    areWebinarOverMetricsVisible: areMetricsVisible,
    webinarViewLink,
    redirectToManagePage,
    isPresenterAloneBeforeWebinar,
    schedule,
    onLiveCountdownZero,
  } = props

  return (
    <div className="webinar-over-overlay-component">
      <div className="content-wrapper">
        <div className="heading">
          {getHeading({
            isProducer,
            name,
            webinarViewLink,
            areMetricsVisible,
            isPresenterAloneBeforeWebinar,
            schedule,
            onLiveCountdownZero,
          })}
        </div>
        <If condition={isProducer}>
          <div className="over-overlay-body-wrapper">
            <If condition={areMetricsVisible}>
              <div className="metrics-wrapper">
                <MetricsBarComponent hideBorders>
                  {map(webinarOverMetrics, (metric) => (
                    <MetricSingleComponent
                      key={metric.title}
                      {...metric}
                      titlePosition="bottom"
                      textAlign="center"
                    />
                  ))}
                </MetricsBarComponent>
              </div>
            </If>
            <Button color="transparent" onClick={redirectToManagePage}>
              <FormattedMessage defaultMessage="Go To Manage Page" />
            </Button>
          </div>
        </If>
      </div>
    </div>
  )
}

WebinarOverlayComponent.propTypes = {
  webinarOverMetrics: PropTypes.arrayOf(PropTypes.object),
  localParticipantName: PropTypes.string,
  isProducer: PropTypes.bool,
  areWebinarOverMetricsVisible: PropTypes.bool,
  webinarViewLink: PropTypes.string,
  redirectToManagePage: PropTypes.func,
  isPresenterAloneBeforeWebinar: PropTypes.bool,
  schedule: PropTypes.object,
  onLiveCountdownZero: PropTypes.func,
}

export default WebinarOverlayComponent
